export enum PoolStatus {
  Draft,
  Open,
  Closed,
  Filled,
}